import React, { useState, useEffect, useRef } from 'react';
import {
    Row, Col, InputGroupText, Input, InputGroup, InputGroupAddon, FormGroup
} from 'reactstrap';
import RoleUserCard from './RoleUserCard';
import NewRoleUserCard from './NewRoleUserCard';
import { getRoles, getRole, getUsers, addUser, addUserRole, getUserRole, saveUserRole, deleteUserRole } from '../../API';
import { store } from '../../Helper';

function Roles(props) {
    const [roles, setRoles] = useState([]);
    const [isLoadingRoles, setIsLoadingRoles] = useState(true);
    const [users, setUsers] = useState([]);
    const [isLoadingUsers, setIsLoadingUsers] = useState(true);


    const [searchOptions, setSearchOptions] = useState({ roleId: 0 });
    const [role, setRole] = useState(null);
    const [isLoadingRole, setIsLoadingRole] = useState(true);
    const [searchTimeout, setSearchTimeout] = useState(false);
    const searchOptionsRef = useRef(searchOptions);
    const searchTimeoutRef = useRef(searchTimeout);
    searchOptionsRef.current = searchOptions;
    searchTimeoutRef.current = searchTimeout;

    const [newUserRoles, setNewUserRoles] = useState([]);

    useEffect(() => {
        fetchRoles();
        fetchUsers();
    }, []);

    useEffect(() => {
        const timeoutSearch = async () => {
            await search();
        };

        const timeout = setTimeout(timeoutSearch, 500);

        return (() => clearTimeout(timeout));
    }, [searchOptions]);

    const fetchUsers = async () => {
        setIsLoadingUsers(true);

        const usersAPIResults = await getUsers();
        setUsers(usersAPIResults);

        setIsLoadingUsers(false);
    }

    const fetchRoles = async () => {
        setIsLoadingRoles(true);

        const rolesAPIResults = await getRoles();
        setRoles(rolesAPIResults);
        if (rolesAPIResults != null && rolesAPIResults.length > 0)
            setSearchOptions({ ...searchOptions, roleId: rolesAPIResults[0].roleID });

        setIsLoadingRoles(false);
    }

    const search = async () => {
        setIsLoadingRole(true);

        const searchAPIResults = await getRole(searchOptionsRef.current.roleId);
        setRole(searchAPIResults);

        setIsLoadingRole(false);
    }

    const getNewUserId = () => {
        return newUserRoles.map(ur => ur.userID).reduce((a, b) => (a < b) ? a : b, 0) - 1;
    };

    const addNewUserRole = () => {
        const newUserRole = { roleID: Number(searchOptions.roleId), userID: getNewUserId() };
        setNewUserRoles([newUserRole, ...newUserRoles]);
    };

    const removeNewUserRole = (roleId, userId) => {
        const tempNewUserRoles = [...newUserRoles];
        const removeIndex = tempNewUserRoles.findIndex(ru => ru.roleID === roleId && ru.userID === userId);
        tempNewUserRoles.splice(removeIndex, 1);
        setNewUserRoles(tempNewUserRoles);
    };

    const saveNewUserRole = async (roleUser) => {
        //Add role user with API
        //if (!store.userRoles.some(ru => ru.roleId === roleId && ru.userId === userId)) {
        //    store.userRoles.push({ roleId, userId });
        //}

        const existingUsers = await getUsers({ exactEmail: roleUser.emailAddress });
        const addableUserRole = { roleID: roleUser.roleID, userID: null };;
        if (existingUsers.length > 0) {
            addableUserRole.userID = existingUsers[0].userID;
        } else {
            //Add user first
            const addedUser = await addUser({ emailAddress: roleUser.emailAddress });
            addableUserRole.userID = addedUser.userID;
        }

        await addUserRole(addableUserRole);
        removeNewUserRole(roleUser.roleId, roleUser.userId);

        search();
    };

    const updateNewUserRole = (userRole, e) => {
        const tempNewUserRoles = [...newUserRoles];
        const updateIndex = tempNewUserRoles.findIndex(ru => ru.roleID === userRole.roleID && ru.userID === userRole.userID);
        tempNewUserRoles[updateIndex] = { ...tempNewUserRoles[updateIndex], [e.target.name]: e.target.value}
        setNewUserRoles(tempNewUserRoles);
    };

    const removeUserRole = async (roleId, userId) => {
        //Remove role user with API
        //const userRoleIndex = store.userRoles.findIndex(ru => ru.roleId === roleId && ru.userId === userId);
        //if (userRoleIndex >= 0) {
        //    store.userRoles.splice(userRoleIndex, 1);
        //}
        await deleteUserRole(userId, roleId);

        search();
    };

    const updateSearch = e => {
        setSearchOptions({
            ...searchOptions,
            [e.target.name]: e.target.value
        });
        setNewUserRoles([]);
    };

    let roleJSX = (<div>No users found...</div>);
    if (isLoadingRole)
        roleJSX = (<div>Loading...</div>);
    else if (role != null) {
        roleJSX = (
            <div>
                {newUserRoles.length > 0 ? newUserRoles.map((ru, i) => (<NewRoleUserCard key={i} users={users} userRole={ru} cancel={removeNewUserRole} save={saveNewUserRole} update={updateNewUserRole} />)) : null}
                {role.userRoles.length > 0 ? role.userRoles.map(ru => (<RoleUserCard key={ru.userID} userRole={ru} remove={removeUserRole} />)) : null}
            </div>
        );
    }

    return (
        <div id="roles">
            <Row xs={2} md={2} lg={3} xl={4} className="justify-content-between search-row">
                <Col>
                    <FormGroup>
                        <InputGroup className="tooltip-parent">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><i className="fas fa-id-badge"></i></InputGroupText>
                            </InputGroupAddon>
                            <Input type="select" name="roleId" value={searchOptions.roleId} onChange={updateSearch}>
                                {roles.map(r => (<option value={r.roleID} key={r.roleID}>{r.roleName}</option>))}
                            </Input>
                            <div className="tooltip-target">
                                Role
                            </div>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col>
                    <div onClick={addNewUserRole} className="action-icon action-add float-right tooltip-parent">
                        <i className="fas fa-plus"></i>
                        <div className="tooltip-target">
                            Add User
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    {roleJSX}
                </Col>
            </Row>
        </div>
    );
}

export default Roles;